import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useDidMountEffect from "../../../../utils/useDidMountEffect";
import useCheckPermission from "../../../../utils/checkPermission";
import {
  createPromoCodeStart,
  getPromoCodesStart,
  updatePromoCodeStart,
  deletePromoCodeStart
} from "../../../../store/redux-slices/promoCodesSlice";
import { toast } from "../../../../components/Toast";


const usePromoCodes = (props) => {
  const { loading, promoCodes } = useSelector(
    (state) => state.promoCodes
  );

  const codes = promoCodes?.data || [];
  const pagination = promoCodes?.pagination || {};

  const isInitialRender = useDidMountEffect();
  const [limit, setLimit] = useState(15);
  const [page, setPage] = useState(1);
  const [type, setType] = useState("");
  const [data, setData] = useState({});
  const [show, setShow] = useState(false);
  const [validation, setValidation] = useState({});
  const [selectedpromoCode, setSelectedpromocode] = useState("")
  const [deletemodal, setDeleteModal] = useState(false)
  const { isHidden } = useCheckPermission();
  const totalPages = pagination?.totalPages;
  const totalCount = pagination?.totalItems;
  const dispatch = useDispatch();

  useEffect(() => {
    setPage(1);
    dispatch(
      getPromoCodesStart({
        limit: limit,
        pageNo: page,
      })
    );
  }, [limit]);

  useEffect(() => {
    !isInitialRender &&
      dispatch(
        getPromoCodesStart({
          limit: limit,
          pageNo: page,
        })
      );
  }, [page]);

  const handleCreateEdit = (type, data) => {
    setType(type);
    setData(data);
    setShow(true);
  };

  const handleDelete = () => {
    dispatch(deletePromoCodeStart({
      "promocodesId": selectedpromoCode?.promocodesId,
      onSuccess: () => {
        dispatch(
          getPromoCodesStart({
            limit: limit,
            pageNo: page,
          })
        );
        setDeleteModal(false)
        setSelectedpromocode("")
      },
    }));
  };

  const handleToggleStatus = (promocodesId, newStatus) => {
    const currentCode = codes.find(code => code.promocodesId === promocodesId);

    if (currentCode) {
      dispatch(updatePromoCodeStart({
        data: {
          promocodesId,
          code: currentCode.code,
          amount: currentCode.amount,
          // validity: currentCode.validity,
          validity: new Date(currentCode.validity).toISOString().split('T')[0],
          status: newStatus,
        },
        optimisticUpdate: true,
        previousStatus: currentCode.status,
        onSuccess: () => {
          // console.log("Status updated successfully");
          toast("Promo code updated successfully", "success");
        },
      }));
    } else {
      console.error('Promo code not found with ID:', promocodesId);
    }
  };

  const onHandleDeleteConfirmation = (data) => {
    setSelectedpromocode(data)
    setDeleteModal(true)
  }

  const createUpdate = (data) => {
    const actionCreator =
      type === "Create"
        ? createPromoCodeStart({
          data: {
            code: data?.code,
            amount: data?.amount,
            validity: data?.validity,
            status: data?.status,
          },
          onSuccess: () => {
            setShow(false);
            dispatch(
              getPromoCodesStart({
                limit: limit,
                pageNo: page,
              })
            );
          },
        })
        : updatePromoCodeStart({
          data: {
            promocodesId: data?.promocodesId,
            code: data?.code,
            amount: data?.amount,
            validity: data?.validity,
            status: data?.status,
          },
          optimisticUpdate: false,
          onSuccess: () => {
            setShow(false);
            dispatch(
              getPromoCodesStart({
                limit: limit,
                pageNo: page,
              })
            );
          },
        });

    dispatch(actionCreator);
  };

  return {
    loading,
    codes,
    handleCreateEdit,
    handleDelete,
    handleToggleStatus,
    type,
    data,
    setShow,
    show,
    createUpdate,
    dispatch,
    isHidden,
    page,
    limit,
    setPage,
    setLimit,
    totalPages,
    validation,
    setValidation,
    setSelectedpromocode,
    selectedpromoCode,
    onHandleDeleteConfirmation,
    deletemodal, setDeleteModal,
    totalCount
  };
};

export default usePromoCodes;
